import React from 'react'
import { Link } from 'react-router-dom'
import styles from './Header.module.css'
import messages from './Header.messages'
import logo from '../../Assets/images/svg/logo.svg'

/**
 * Header component.
 * @returns {void} .
 */
const Header = () => (
  <header
    id="header"
    className={styles.MainContainer}
  >
    <div className={styles.Logo}>
      <Link
        to="/"
        className={styles.LinkHome}
      >
        <img
          alt="logo"
          src={logo}
        />
      </Link>
      <div className={styles.Title}>
        {messages.titlePlatform}
      </div>
    </div>
  </header>
)
export default Header
